// src/pages/DirectoryPage.js (SON HALİ)

import React, { useState, useEffect, useCallback } from 'react';
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from '../config/firebaseConfig.js';
import { Helmet } from 'react-helmet-async';

import { useAuth } from '../context/AuthContext.js';
import Paywall from '../components/directory/Paywall.js';
import VideoHero from '../components/shared/VideoHero.js';
import SubmissionModal from '../components/directory/SubmissionModal.js';
import DirectoryFilters from '../components/directory/DirectoryFilters.js';
import DirectoryList from '../components/directory/DirectoryList.js';

const allCategories = [
    "Authors", "Illustrators", "Editors", "Agent", "Publishers", 
    "Distributors", "Marketing", "Platforms", "Printers", "Stockists"
];

const DirectoryPage = () => {
    // Mevcut state'ler
    const [listings, setListings] = useState([]);
    const [filteredListings, setFilteredListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [showModal, setShowModal] = useState(false);

    const { userData } = useAuth();

    const fetchListings = useCallback(async () => {
        setLoading(true);
        try {
            const listingsRef = collection(db, "professionals");
            const q = query(listingsRef, where("status", "==", "approved"), orderBy("createdAt", "desc"));
            const snapshot = await getDocs(q);
            const listingsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
            const sortedData = listingsData.sort((a, b) => {
                return allCategories.indexOf(a.category) - allCategories.indexOf(b.category);
            });
            
            setListings(sortedData);
            setFilteredListings(sortedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    }, []); 

    useEffect(() => {
        fetchListings();
    }, [fetchListings]);

    useEffect(() => {
        let results = [...listings];
        if (selectedCategory !== 'All') {
            results = results.filter(p => p.category === selectedCategory);
        }
        if (searchTerm) {
            const lowercasedTerm = searchTerm.toLowerCase();
            results = results.filter(p => p.name.toLowerCase().includes(lowercasedTerm));
        }
        setFilteredListings(results);
    }, [searchTerm, selectedCategory, listings]);

    // --- DEĞİŞTİRİLEN İZİN KONTROL MANTIĞI ---
    const isSubscribed = userData?.role === 'subscribedUser' || userData?.role === 'admin';
    const freeCategories = ['Authors', 'Illustrators', 'Editors', 'All'];
    const isProtectedCategory = !freeCategories.includes(selectedCategory);
    const canViewContent = !isProtectedCategory || isSubscribed;
    // --- BİTTİ ---

    return (
        <>
            <Helmet>
                <title>Publishing Professionals Directory</title>
                <meta name="description" content="Find and connect with authors, illustrators, editors, and other publishing professionals in our comprehensive directory." />
            </Helmet>

            <VideoHero
                title="Join Our Story"
                tagline="Connect with authors, illustrators, editors, and more."
            />
            
            <div className="py-5 bg-light">
                <div className="container text-center">
                    <h2 className="fw-light">Are you a professional?</h2>
                    <p className="lead text-muted mb-4">
                        Join our growing community and get discovered by creators from around the world.
                    </p>
                    <button className="btn btn-primary btn-lg" onClick={() => setShowModal(true)}>
                        <i className="bi bi-plus-circle-fill me-2"></i> Add Your Listing
                    </button>
                </div>
            </div>
            
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <DirectoryFilters
                            searchTerm={searchTerm}
                            selectedCategory={selectedCategory}
                            onSearchChange={(e) => setSearchTerm(e.target.value)}
                            onCategoryChange={(e) => setSelectedCategory(e.target.value)}
                        />
                    </div>
                </div>

                <div className="mt-5">
                    {canViewContent ? (
                        <DirectoryList 
                            listings={filteredListings}
                            loading={loading}
                            allCategories={selectedCategory === 'All' ? allCategories : [selectedCategory]}
                             userData={userData}
                        />
                    ) : (
                        <Paywall />
                    )}
                </div>
            </div>
            
            <SubmissionModal 
                show={showModal} 
                handleClose={() => setShowModal(false)} 
            />
        </>
    );
};

export default DirectoryPage;